module.exports = __webpack_public_path__ + "static/media/1.00ac7da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Urolift/Images/1.png
// module id = 644
// module chunks = 0